import React, { createContext, useContext, useMemo, useState } from "react"

export type MessageCustomerMigration = {
    value: boolean
    message: {
        fr: string
        en: string
    }
}

type FeatureFlagsState = {
    multiOrganizationEnabled: boolean
    vidAutochargeEnabled: boolean
    gdprMessageEnabled: MessageCustomerMigration | null
    setMultiOrganizationEnabled: (value: boolean) => void
    setVidAutochargeEnabled: (value: boolean) => void
    setGdprMessageEnabled: (value: MessageCustomerMigration | null) => void
}

const defaultState: FeatureFlagsState = {
    multiOrganizationEnabled: false,
    vidAutochargeEnabled: false,
    gdprMessageEnabled: null,
    setMultiOrganizationEnabled: () => {},
    setVidAutochargeEnabled: () => {},
    setGdprMessageEnabled: () => null,
}

const FeatureFlagsContext = createContext<FeatureFlagsState>(defaultState)

export const FeatureFlagsProvider = ({
    children,
}: {
    children: React.ReactNode
}) => {
    const [multiOrganizationEnabled, setMultiOrganizationEnabled] =
        useState<boolean>(false)
    const [vidAutochargeEnabled, setVidAutochargeEnabled] =
        useState<boolean>(false)
    const [gdprMessageEnabled, setGdprMessageEnabled] =
        useState<MessageCustomerMigration | null>(null)

    const value = useMemo(
        () => ({
            multiOrganizationEnabled,
            setMultiOrganizationEnabled,
            vidAutochargeEnabled,
            setVidAutochargeEnabled,
            gdprMessageEnabled,
            setGdprMessageEnabled,
        }),
        [multiOrganizationEnabled, vidAutochargeEnabled, gdprMessageEnabled]
    )

    return (
        <FeatureFlagsContext.Provider value={value}>
            {children}
        </FeatureFlagsContext.Provider>
    )
}

export const useFeatureFlags = () => useContext(FeatureFlagsContext)
